export function CustomerService(CustomerLite, inheritorApi) {
  var Customer = function (customer) {
    this.customer = customer;

    inheritorApi.inherit(this, CustomerLite);
  };

  inheritorApi.bootstrap(Customer, CustomerLite);

  return Customer;
}
